export default {
  props: {
    productReviews: {
      type: Array,
      default: () => [],
    },

    productUrlKey: {
      type: String,
      default: '',
    },

    vendor: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ratingPerVendor () {
      return this.productReviews?.find(review => +review.vendorId === +this.vendor.vendorId)
    },
  },
}
